import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/image/pc.png';
import _imports_1 from '../../assets/image/phone.png';
const _withScopeId = n => (_pushScopeId("data-v-855e9fee"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "v-index-img-item-box img-border"
};
const _hoisted_2 = {
  class: "intrinsic-aspect-ratio-container"
};
const _hoisted_3 = {
  class: "video-tag-list"
};
const _hoisted_4 = {
  key: 0,
  class: "tag-item flex-align-center t-4k"
};
const _hoisted_5 = {
  key: 1,
  class: "tag-item flex-align-center t-free"
};
const _hoisted_6 = {
  key: 0,
  class: "img-hover-box flex-start"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  key: 1,
  class: "img-hover-box img-placeholder flex-start"
};
const _hoisted_9 = ["src"];
const _hoisted_10 = {
  class: "img-pos-desc flex-align-between"
};
const _hoisted_11 = {
  class: "duration"
};
const _hoisted_12 = {
  class: "history-right"
};
const _hoisted_13 = {
  class: "img-title double-line-ellipsis"
};
const _hoisted_14 = {
  class: "history-time"
};
const _hoisted_15 = {
  key: 0,
  src: _imports_0,
  alt: ""
};
const _hoisted_16 = {
  key: 1,
  src: _imports_1,
  alt: ""
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");
  const _directive_lazy = _resolveDirective("lazy");
  return _openBlock(), _createBlock(_component_router_link, {
    target: "_blank",
    to: {
      path: $options.targetUrl,
      query: {
        ..._ctx.$route.query,
        fpos: `${$props.dataPart || _ctx.$route.name}-HistoryItem`
      }
    },
    class: _normalizeClass(["flex-start", [$props.item.isShu == 1 ? 'img-blur' : '']]),
    title: $props.item.title,
    id: $props.item.id
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [['4k', '4K'].includes($props.item.quality) ? (_openBlock(), _createElementBlock("div", _hoisted_4)) : _createCommentVNode("", true), $props.item.isFree == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_5)) : _createCommentVNode("", true)]), $props.item.isShu == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", {
      style: _normalizeStyle(`background-image: url('${$props.item.coverImg}')`),
      class: "img-mbl"
    }, [_withDirectives((_openBlock(), _createElementBlock("img", {
      class: "img-cover img-placeholder",
      key: $props.item.id
    })), [[_directive_lazy, $props.item.coverImg]]), $data.detail.smallVideo && $data.showDetailDialog ? (_openBlock(), _createElementBlock("video", {
      key: 0,
      class: "img-cover",
      muted: "",
      ref: "coverVideo",
      loop: "",
      src: $data.detail.smallVideo
    }, null, 8, _hoisted_7)) : _createCommentVNode("", true)], 4)])) : (_openBlock(), _createElementBlock("div", _hoisted_8, [$props.item.isShu != 1 ? _withDirectives((_openBlock(), _createElementBlock("img", {
      class: "img-cover",
      key: $props.item.id
    })), [[_directive_lazy, $props.item.coverImg]]) : _createCommentVNode("", true), $data.detail.smallVideo && $data.showDetailDialog ? (_openBlock(), _createElementBlock("video", {
      key: 1,
      class: "img-cover",
      muted: "",
      ref: "coverVideo",
      loop: "",
      src: $data.detail.smallVideo
    }, null, 8, _hoisted_9)) : _createCommentVNode("", true)])), _createElementVNode("div", _hoisted_10, [_createElementVNode("p", _hoisted_11, _toDisplayString($props.item.durationNew), 1)])])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("p", _hoisted_13, _toDisplayString($props.item.title), 1), _createElementVNode("div", _hoisted_14, [$props.item.ident == 'pc' ? (_openBlock(), _createElementBlock("img", _hoisted_15)) : (_openBlock(), _createElementBlock("img", _hoisted_16)), _createElementVNode("span", null, _toDisplayString($props.item.time), 1)])])]),
    _: 1
  }, 8, ["to", "class", "title", "id"]);
}